import { LoginSuccessPage, NavigationHandler, PlatformProvider } from '@elva/platform';
import { Outlet } from 'react-router-dom';
import { digitalMarketingPlatformConfig } from '@/app/config/platform';

const LOGO_SRC = '/logo.svg';

export function AppRoot() {
  return (
    <PlatformProvider config={digitalMarketingPlatformConfig} logoSrc={LOGO_SRC}>
      <NavigationHandler />
      <Outlet />
    </PlatformProvider>
  );
}

export function LoginOkRoute() {
  return <LoginSuccessPage logoSrc={LOGO_SRC} redirectTo="/" />;
}
